import { render, staticRenderFns } from "./KataPengantar.vue?vue&type=template&id=7065e28a&"
import script from "./KataPengantar.vue?vue&type=script&lang=js&"
export * from "./KataPengantar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports